import styled from 'styled-components';

export const Flex = styled.div<{ justifyContent?: string }>`
    display: flex;
    justify-content: ${(props) => props.justifyContent || 'center'};
    align-items: center;
`;
